import Relay from 'react-relay'
import PersonEntry from './PersonEntry'

const PersonEntryContainer = Relay.createContainer(PersonEntry, {
    fragments: {
        person: () => Relay.QL`
            fragment on Person {
                id,
                PerNameTxt,
                PerNameSortedTxt,
                PerDatingTxt,
                PerThumbnail,
                PerTypeVoc,
                PerBirthPlaceCity,
                PerBirthPlaceCountry,
            }
        `
    }
});

export default PersonEntryContainer;


// WEBPACK FOOTER //
// ./app/components/Person/Entry/index.js